export default function getCenterFromBounding(bounding) {
  return {
    x: bounding.left + bounding.width / 2,
    y: bounding.top + bounding.height / 2,
  };
}
